export default {
  directionSectorCode: {},
  directionSectorCodes: [],
  directions: [],
  categorySubjects: [],
}
